import React, {useMemo} from "react";
import {useSearchParams} from "react-router-dom";
import CustomEmpty from "../components/custom-empty";
import ViewerWmsMap from "../components/viewer-wms-map";

const WmsViewerPage = () => {
  const [searchParams] = useSearchParams();

  const serviceUrlParam = useMemo(() => searchParams.get("serviceUrl") || null, [searchParams]);

  const layersParam = useMemo(() => searchParams.get("layers") || null, [searchParams]);
  const layers = useMemo(
    () => (layersParam ? layersParam.split(",").filter(l => (l || "").length > 0) : []),
    [layersParam]
  );

  return !serviceUrlParam ? (
    <CustomEmpty sx={{background: "#f5f5f5"}} />
  ) : (
    <ViewerWmsMap serviceUrl={serviceUrlParam} visibleLayers={layers} />
  );
};

export default WmsViewerPage;
